<template>
  <el-form :model="form" :rules="rules" ref="form" @submit.prevent.native="onSubmit">
    <app-placeholder-horizontal :imageId="form.image_id" @upload="onUpload"/>
    <el-form-item label="Product title" prop="title">
      <el-input v-model="form.title" placeholder="Enter a product title"></el-input>
    </el-form-item>
    <div class="row">
      <div class="col-12 col-md-4">
        <el-form-item label="Category" prop="category">
          <app-categories v-model="form.category.id"/>
        </el-form-item>
      </div>
      <div class="col-12 col-md-4">
        <el-form-item label="Brand" prop="brand">
          <app-brands v-model="form.brand.id"/>
        </el-form-item>
      </div>
      <div class="col-12 col-md-4">
        <el-form-item label="YouTube ID">
          <el-input v-model="form.youtube_id"></el-input>
        </el-form-item>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-6">
        <el-form-item label="Product line">
          <el-input v-model="form.series"></el-input>
        </el-form-item>
      </div>
      <div class="col-12 col-md-6">
        <el-form-item label="Country (Made In)">
          <app-countries v-model="form.country_id" />
        </el-form-item>
      </div>
    </div>
    <el-form-item label="Description" prop="desc">
      <el-input v-model="form.desc" type="textarea" rows="5" placeholder="Enter a product description"></el-input>
    </el-form-item>
    <el-form-item label="Notes">
      <el-input id="mde" v-model="form.notes" type="textarea"></el-input>
    </el-form-item>
    <el-form-item label="Package contents (separate with comma)">
      <el-input v-model="form.contents_formatted"></el-input>
    </el-form-item>
    <el-form-item label="Materials (separate with comma)">
      <el-input v-model="form.materials_formatted"></el-input>
    </el-form-item>
    <el-form-item label="Care and handling">
      <el-input v-model="form.handling" type="textarea" rows="5"></el-input>
    </el-form-item>
    <el-button native-type="submit" type="primary" :loading="loading">Save</el-button>
  </el-form>
</template>

<script>
import SimpleMDE from 'simplemde'
import AppBrands from '@/components/App/AppBrands'
import AppCategories from '@/components/App/AppCategories'
import AppCountries from '@/components/App/AppCountries'
import AppPlaceholderHorizontal from '@/components/App/AppPlaceholderHorizontal'

export default {
  components: {
    AppBrands,
    AppCategories,
    AppCountries,
    AppPlaceholderHorizontal,
  },

  props: {
    product: Object,
  },

  data() {
    return {
      loading: false,
      form: this.product,
      rules: {
        'brand': [
          { required: true, message: 'Select a brand.', trigger: 'blur' },
        ],
        'category': [
          { required: true, message: 'Select a category.', trigger: 'blur' },
        ],
        'desc': [
          { required: true, message: 'Enter a product description.', trigger: 'blur' },
          { min: 140, max: 280, message: 'Length should be 140 to 280.', trigger: 'blur' },
        ],
        'title': [
          { required: true, message: 'Enter a product title.', trigger: 'blur' },
          { max: 64, message: 'Length should be up to 64.', trigger: 'blur' },
        ],
      },
    }
  },

  mounted() {
    var mde = new SimpleMDE({ element: document.getElementById('mde') })
    mde.codemirror.on('change', () => {
      this.form.notes = mde.value()
    })
  },

  methods: {
    async onSubmit() {
      this.$refs['form'].validate(async valid => {
        if (!valid) {
          return false
        }

        this.loading = true

        try {
          var { data } = await this.$http.put(`/products/${ this.product.id }`, {
            brand: this.form.brand,
            category: this.form.category,
            contents: this.form.contents_formatted.split(', '),
            country_id: this.form.country_id,
            desc: this.form.desc,
            handling: this.form.handling,
            materials: this.form.materials_formatted.split(', '),
            notes: this.form.notes,
            series: this.form.series,
            title: this.form.title,
            youtube_id: this.form.youtube_id,
          })
        } catch(err) {
          this.$message.error(err.response.data.message)
          return false
        } finally {
          this.loading = false
        }

        this.$message.success(data.message)
      })
    },

    async onUpload(imageId) {
      try {
        var { data } = await this.$http.put(`/products/${ this.product.id }/image`, {
          image_id: imageId,
          orientation: 'h',
        })
      } catch(err) {
        this.$message.error(err.response.data.message)
        return false
      }

      this.$message.success(data.message)
    },
  },
}
</script>
